import { operationQueue } from '../utils/offlineStorage';
import { supabase } from './client';

export function queueOperation(
  type: 'create' | 'update' | 'delete',
  table: string,
  data: any
): void {
  operationQueue.enqueue({ type, table, data });
  console.log(`Operation queued for later: ${type} on ${table}`);
}

export async function processQueuedOperations(): Promise<{
  success: number;
  failed: number;
}> {
  const queue = operationQueue.getQueue();
  let success = 0;
  let failed = 0;

  console.log(`Processing ${queue.length} queued operations...`);

  for (const operation of queue) {
    try {
      switch (operation.type) {
        case 'create':
          await supabase.from(operation.table).insert(operation.data);
          break;
        case 'update':
          await supabase.from(operation.table).update(operation.data).eq('id', operation.data.id);
          break;
        case 'delete':
          await supabase.from(operation.table).delete().eq('id', operation.data.id);
          break;
      }
      operationQueue.dequeue(operation.id);
      success++;
    } catch (error) {
      console.error('Failed to process queued operation:', error);
      failed++;
    }
  }

  console.log(`Queued operations processed: ${success} success, ${failed} failed`);
  return { success, failed };
}
